import clsx from 'clsx'

const defaultTextProps = {
  heading: 'Now watch how easy it is!'
}

export function DemoVideo(props) {
  const {
    textProps = defaultTextProps,
    src = 'https://www.youtube-nocookie.com/embed/y7ifPwKZA3c?si=4cDpHP3zWQw4mEvX&rel=0&?list='
  } = props
  return (
    <div
      className={clsx(
        'pb-[160px] px-[40px]',
        'max-[768px]:pb-[80px] max-[768px]:px-[16px]'
      )}
    >
      <div className='flex mx-auto max-w-[1280px] items-center flex-col gap-[40px]'>
        <div className='w-auto max-w-[1280px] flex mx-auto items-start justify-center gap-[8px]'>
          <h3 className='text-[52px] text-center font-[700] leading-[110%] mb-0 tracking-[-2px]'>
            {textProps?.heading}
          </h3>
        </div>
        <div className={clsx('overflow-hidden rounded-2xl')}>
          <iframe
            src={src}
            title='Now watch how easy it is!'
            allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
            referrerPolicy='strict-origin-when-cross-origin'
            allowFullScreen
            className='h-[28vw] aspect-[1280/720] w-full max-[991px]:h-[46vw] max-[768px]:h-[54vw]'
          ></iframe>
        </div>
      </div>
    </div>
  )
}
